import { fetchAllRfqData } from '../../database/fetch-rfq-data';

const getRfqData = (callback) => {
  return fetchAllRfqData((rfqs) => {
    const rfqData = rfqs
      .filter((rfq) => rfq && rfq.status !== 'no bid') // Filter out null and "no bid" status RFQs
      .map((rfq) => {
        const toJsDate = (value) => {
          if (!value) return null;
          if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
          if (typeof value === 'string') {
            // Leave strings as-is for display to avoid timezone shifts
            return value;
          }
          if (typeof value === 'object') {
            if (typeof value.toDate === 'function') {
              const d = value.toDate();
              return isNaN(d.getTime()) ? null : d;
            }
            if (typeof value.seconds === 'number') {
              const d = new Date(value.seconds * 1000);
              return isNaN(d.getTime()) ? null : d;
            }
          }
          return null;
        };

        const formatMmDdYyyyUTC = (date) => {
          if (!date) return '';
          const mm = (date.getUTCMonth() + 1).toString().padStart(2, '0');
          const dd = date.getUTCDate().toString().padStart(2, '0');
          const yyyy = date.getUTCFullYear();
          return `${mm}-${dd}-${yyyy}`;
        };

        const computeDueBy = (due) => {
          if (!due) return '';
          if (typeof due === 'string') {
            // Already a string date; show as-is to keep the original day across timezones
            return due;
          }
          // For Date objects (e.g., Firestore Timestamp converted), format in UTC
          return formatMmDdYyyyUTC(due);
        };

        const dueParsed = toJsDate(rfq?.dueDate);
        const formattedDate = computeDueBy(dueParsed);

        const originalReleaseDate = new Date(rfq.releaseDate);
        const releaseDay = originalReleaseDate.getDate();
        const releaseMonth = originalReleaseDate.getMonth() + 1;
        const releaseYear = originalReleaseDate.getFullYear();
        const formattedReleaseDate = `${releaseMonth
          .toString()
          .padStart(2, '0')}-${releaseDay
            .toString()
            .padStart(2, '0')}-${releaseYear}`;

        const timestamp = originalReleaseDate
          ? originalReleaseDate.getTime()
          : (dueParsed && typeof dueParsed !== 'string' ? dueParsed.getTime() : Date.now());
        return {
          uniqueId: rfq?.rfqId,
          rfqNo: rfq?.rfqNo?.toString() || '',
          agency: rfq?.agency || '',
          email: rfq?.primaryEmail || '',
          emailSubject: rfq?.emailSubject || '',
          dueBy: formattedDate,
          lineItems: rfq?.items?.length || 0,
          attachments: rfq?.attachments
            ? Math.max(0, rfq?.attachments.length - 1)
            : 0,
          quotes: rfq?.quotes?.length || 0,
          assignedTo: rfq?.assignedTo || '',
          status: rfq?.status || '',
          releaseDate: formattedReleaseDate,
          releaseDateObject: originalReleaseDate,
          realeseDateTimestamp: timestamp,
          timestamp: rfq?.timestamp ? rfq?.timestamp : timestamp,
          comments: rfq.comments || '',
        };
      })
      .sort((a, b) => b.timestamp - a.timestamp);

    rfqData.forEach((item, index) => {
      item.no = index + 1; // Adjust serial numbers based on the filtered and sorted list
      delete item.releaseDateObject;
    });
    callback(rfqData);
  });
};

export default getRfqData;
